module.exports = __webpack_public_path__ + "statics/img/all.6d96ee7f.jpg";